import api from '@/api'
import Report from '@/api/communique/report'
import types from '@/types'

export interface OTTImpressionsByDayPartStat {
  day_of_week: string
  impressions: number
}

export interface queryParams {
  companyId: string
  mediaTypes: string[]
  startDate?: string
  endDate?: string
  excludedInitiativeIDs?: string[]
  includedInitiativeIDs?: string[]
}

export class OTTImpressionsByDayPartStatsModel {
  public async fetchAll({
    companyId,
    mediaTypes,
    startDate,
    endDate,
    excludedInitiativeIDs,
    includedInitiativeIDs,
  }: queryParams): Promise<Report<OTTImpressionsByDayPartStat>> {
    return api('report.dashboards.ihmCompany.ott.impressionsByDayPartStats')
      .params({
        companyId: companyId,
        media_types: mediaTypes,
        start_date: startDate,
        end_date: endDate,
        exclude_initiative_ids: excludedInitiativeIDs,
        include_initiative_ids: includedInitiativeIDs,
      })
      .cache(1000 * types.config.dashboardCacheSeconds())
      .jsonMust<Report<OTTImpressionsByDayPartStat>>()
  }
}
